export const ONBOARDING_STEPS_WITH_FLOATING_AGENT: ReadonlySet<string> = new Set([
  "mem-agent-shortcut",
  "mem-agent-first-message",
  "existing-user-mem-agent-first-message",
]);
